import { render, staticRenderFns } from "./CreateConvPage.vue?vue&type=template&id=c2bddf9c"
import script from "./CreateConvPage.js?vue&type=script&lang=js&external"
export * from "./CreateConvPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports